//
//
//
import myAxios from '../functions/myAxios';

export default async function getCostsName() {
  //
  try {
    let res = await myAxios({method: 'get', url: '/api/costs/name'});
    if (res && res.data) {
      // console.log(res.data);
      return res.data
    }
  } catch (e) {
    console.log(e);
    return;
  }
  //end
}
